import {
  aLogMapping,
  aLogMappingOptions,
  aLogMappingRecordTypeOption,
  mockSchemaFieldQueryOperationQuery,
} from '__generated__';

export const handlers = [
  mockSchemaFieldQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        logMappingOptions: aLogMappingOptions(
          {
            recordTypeOptions: [
              aLogMappingRecordTypeOption({
                objectType: aLogMapping().recordType,
              }),
            ],
          },
          new Set<string>([
            'fieldValueTypeOptions',
            'logFormatOptions',
            'parsingPatternOptions',
          ])
        ),
      })
    );
  }),
];
